import { render, staticRenderFns } from "./IntegrationBox.vue?vue&type=template&id=6a517199&scoped=true&"
import script from "./IntegrationBox.vue?vue&type=script&lang=ts&"
export * from "./IntegrationBox.vue?vue&type=script&lang=ts&"
import style0 from "./IntegrationBox.vue?vue&type=style&index=0&id=6a517199&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a517199",
  null
  
)

export default component.exports